import { gql } from '@apollo/client';

export default gql`
  mutation createMultiSections($data: String) {
    createMultiSections(data: $data) {
      ok
      message
      error
    }
  }
`;
